import { SET_MENU } from "./action-types";
export const setMenuAction = (key) => ({ type: SET_MENU, data: key });
